import { Integrations } from '@sentry/tracing';
import { DEFAULT_IGNORE_ERRORS } from './constants';
import { createDebug } from '@rambler-id/debug';
const debug = createDebug('common:sentry');
export class Sentry {
    constructor(sdk) {
        this.init = (options) => {
            const { dsn, sampleRate, environment, release, tags, ignoreErrors, ...restInitOptions } = options;
            if (!dsn)
                return;
            this.environment = environment;
            if (environment === 'development') {
                debug('init');
                return;
            }
            const customIgnoreErrors = !ignoreErrors
                ? []
                : Array.isArray(ignoreErrors)
                    ? ignoreErrors
                    : [ignoreErrors];
            this.sdk.init({
                dsn,
                sampleRate,
                tracesSampleRate: sampleRate,
                environment,
                release,
                integrations: [
                    new Integrations.BrowserTracing({ traceFetch: false, traceXHR: false })
                ],
                ignoreErrors: [...DEFAULT_IGNORE_ERRORS, ...customIgnoreErrors],
                initialScope: { tags },
                ...restInitOptions
            });
        };
        this.captureException = (error, context = {}) => {
            const sentryInitialized = !!this.environment;
            if (!sentryInitialized || !error)
                return;
            if (this.environment === 'development') {
                debug('captureException %O %O', error, context);
                return;
            }
            this.sdk.withScope((scope) => {
                if ('code' in error)
                    scope.setExtra('code', error.code);
                if ('details' in error)
                    scope.setExtra('details', error.details);
                for (const key in context) {
                    if (context.hasOwnProperty(key)) {
                        scope.setExtra(key, context[key]);
                    }
                }
                this.sdk.captureException(error);
            });
        };
        this.sdk = sdk;
    }
}
